/**
 * Points the auth stack at a platform instance (Layer 0). This browser configuration intentionally
 * contains only a public base URL; API keys and organization secrets belong in Workers.
 */
export interface AuthConfig {
  apiBaseUrl: string;
}

let current: AuthConfig | null = null;

export function configureAuth(config: AuthConfig): void {
  current = config;
}

export function getAuthConfig(): AuthConfig {
  if (!current) {
    throw new Error('configureAuth() must be called before using the auth package');
  }
  return current;
}
